import axios from 'axios';

export default {
  custAxios() {
    return axios.create({
      baseURL : process.env.PLATAFORMA_API,
      headers : {
        'Access-Control-Allow-Origin' : '*',
        'Content-Type'                : 'application/json',
        'accept-language'             : (window.$nuxt && window.$nuxt.$store && window.$nuxt.$store.state && window.$nuxt.$store.state._core && window.$nuxt.$store.state._core.user && window.$nuxt.$store.state._core.user.languageId && window.$nuxt.$store.state._core.user.languageId) || 'pt-BR',
        Authorization                 : window?.$nuxt?.$token?.get(),
        'x-user-timezone'             : window.$nuxt?.$store?.state?._core?.user?.timezone || 'America/Sao_Paulo'
      }
    });
  }
};
